import {Injectable} from '@angular/core';
import {LocalStorageService} from './local-storage.service';
import {Observable, of} from 'rxjs';
import {HttpClient, HttpParams} from '@angular/common/http';
import {ApiRoutes} from '../../../config/api-routes';

@Injectable()
export class LocalizationService {

  private supportedLanguages: string[];
  private supportedLanguages$: Observable<string[]>;

  constructor(private httpClient: HttpClient, private routes: ApiRoutes, private localStorage: LocalStorageService) {}

  public init() {
    this.initSupportedLanguages();
  }

  public getStartingLanguage() {
    let result = this.localStorage.getCulture();
    if (!result) {
      result = navigator.language;
    }
    return result;
  }

  public setCulture(culture: string): Observable<any> {
        return of();
  }

  public getSupportedLanguages(): Observable<string[]> {
    return (this.supportedLanguages == null) ? this.supportedLanguages$ : of(this.supportedLanguages);
  }

  private initSupportedLanguages() {
    this.supportedLanguages$ = this.getSupportedLanguagesFromServer();
    this.supportedLanguages$.subscribe(response => this.supportedLanguages = response);
  }

  private getSupportedLanguagesFromServer(): Observable<string[]> {
        return of([]);
  }
}

